import { Link } from "react-router-dom";
import type { NewsArticle } from "@/types/news";
import { formatViews, relativeTime } from "@/utils/news";

export default function RelatedList({ title, list }: { title: string; list: NewsArticle[] }) {
  if (list.length === 0) return null;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center gap-2">
        <span className="h-5 w-1.5 rounded-full bg-primary-500" />
        <h3 className="font-heading text-base font-bold text-foreground-950">{title}</h3>
      </div>
      <div className="space-y-1">
        {list.map((item) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex gap-3 rounded-md p-2 transition-colors hover:bg-background-100"
          >
            <div className="h-16 w-20 shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={item.cover}
                alt={item.title}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex min-w-0 flex-1 flex-col justify-between">
              <p className="news-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                {item.title}
              </p>
              <p className="flex items-center gap-2 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-time-line" />
                  {relativeTime(item.publishTime)}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" />
                  {formatViews(item.views)}
                </span>
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}